// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toastify {
  position: fixed;
  z-index: 10002;
}
.Toastify .Toastify__toast-container--top-center {
  top: 0.6em;
}
.Toastify .Toastify__toast-body.wide {
  padding: 0 10%;
}
.toastContainer {
  top: 90px;
}
.toastContainer .toast {
  border: 2px solid #4d3c64;
  color: #fff;
  text-align: center;
  font-size: 17px;
}
.toastContainer .toastBody {
  margin: auto 0;
}
.toastContainer .toastProgress {
  background: linear-gradient(225deg, #51b384 0%, #008080 100%);
}
.toastContainer .Toastify__close-button {
  color: #fff;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/commonComponents/ToastContainer.less"],"names":[],"mappings":"AAAA;EAEC,eAAA;EACA,cAAA;AAAD;AAHA;EAME,UAAA;AAAF;AANA;EAUE,cAAA;AADF;AAKA;EACC,SAAA;AAHD;AAEA;EAIE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAHF;AAJA;EAWE,cAAA;AAJF;AAPA;EAeE,6DAAA;AALF;AAVA;EAmBE,WAAA;EACA,YAAA;AANF","sourcesContent":[".Toastify {\n\t// must be more than Kendo style .k-dialog-wrapper (last seen as 10001)\n\tposition: fixed;\n\tz-index: 10002;\n\n\t.Toastify__toast-container--top-center {\n\t\ttop: 0.6em;\n\t}\n\n\t.Toastify__toast-body.wide {\n\t\tpadding: 0 10%;\n\t}\n}\n\n.toastContainer {\n\ttop: 90px;\n\n\t.toast {\n\t\tborder: 2px solid #4d3c64;\n\t\tcolor: #fff;\n\t\ttext-align: center;\n\t\tfont-size: 17px;\n\t}\n\n\t.toastBody {\n\t\tmargin: auto 0;\n\t}\n\n\t.toastProgress {\n\t\tbackground: linear-gradient(225deg, rgba(81, 179, 132, 1) 0%, rgba(0, 128, 128, 1) 100%);\n\t}\n\n\t.Toastify__close-button {\n\t\tcolor: #fff;\n\t\topacity: 0.8;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
